(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miraya-ad-crosssell"]) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('.miraya-crosssell__select')) return;
  const option = event.target.selectedOptions[0];
  const card = event.target.closest('.miraya-crosssell__card');
  card.querySelector('[data-companion-price]').textContent = option.dataset.price;
  card.querySelector('[data-companion-link]').href = option.dataset.url;
  const image = card.querySelector('.miraya-crosssell__image');
  if (image && option.dataset.image) {
    image.removeAttribute('srcset');
    image.src = option.dataset.image;
  }
  card.querySelector('[role="status"]').textContent = '';
});
document.addEventListener('submit', async function(event) {
  const form = event.target.closest('.miraya-crosssell__form');
  if (!form) return;
  event.preventDefault();
  const section = form.closest('.miraya-crosssell');
  const button = form.querySelector('button');
  const select = form.querySelector('select');
  const status = form.querySelector('[role="status"]');
  const payload = new FormData(form);
  button.disabled = true;
  if (select) select.disabled = true;
  status.textContent = '';
  try {
    const response = await fetch(section.dataset.addUrl + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: payload
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || section.dataset.error);
    status.textContent = section.dataset.added;
    try {
      const cartResponse = await fetch(section.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
        document.querySelectorAll('[data-cart-count-bubble]').forEach(element => element.classList.toggle('hide', cart.item_count === 0));
      }
    } catch (_) { /* The item was added even if the optional header refresh fails. */ }
  } catch (error) {
    status.textContent = error.message || section.dataset.error;
  } finally {
    button.disabled = false;
    if (select) select.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
